import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('ls-dropdown-button')
export class LsDropdownButton extends LitElement {
    static styles = css`
        .ls-dropdown-button {
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .arrow {
            width: 10px;
            height: 6px;
            position: relative;
            transition: all 0.3s ease;
        }

        .arrow:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 6px solid #333;
            user-select: none;
        }

        .rotate {
            transform: rotate(-180deg);
        }
    `;

    @property({ type: Boolean })
    isActive: boolean = false;

    render() {
        return html`<div class="ls-dropdown-button">
            <slot></slot>
            <span class="arrow ${this.isActive ? 'rotate' : ''}"></span>
        </div>`;
    }
}
